import { RootState } from "@/app/stores";
import { getTradingPartners, ITradingPartner } from "@/shared/api/trading";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchTradingPartners = createAsyncThunk<
    ITradingPartner[],
    void,
    { state: RootState }
>('socialMarketPartners/fetchTradingPartners', async (_, thunkAPI) => {
    try {
        const { searchQuery } = thunkAPI.getState().socialMarketPartners
        const response = await getTradingPartners(searchQuery, "partner")
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})